import { registerComponent, loading } from "helpers";
import { WYATTElement } from "wyatt";

registerComponent(
  "adoption-search-course-list",
  class AdoptionSearchCourseList extends WYATTElement {
    constructor() {
      super();

      this.listElement = this.querySelector("ul");
    }

    connectedCallback() {
      loading.add(this);
    }

    disconnectedCallback() {
      loading.remove(this);
    }

    get templates() {
      return {
        listItem: document.getElementById("adoption-search-course-list-item")
          .content,
      };
    }

    buildCourseDataByCourseId(data) {
      return data.items.reduce((acc, item) => {
        acc[item.course_id] = item;
        return acc;
      }, {});
    }

    render(textbookData, courseIds) {
      loading.remove(this);

      const courseDataByCourseId = this.buildCourseDataByCourseId(textbookData);

      courseIds.forEach((courseId) => {
        const listItemElement = this.templates.listItem.cloneNode(true);

        const dataItem = courseDataByCourseId[courseId];

        listItemElement.querySelector(
          ".adoption-search__course-list-item-link"
        ).href = `#${courseId}`;

        listItemElement.querySelector(
          ".adoption-search__course-list-item-name"
        ).textContent = dataItem.course_name;

        listItemElement.querySelector(
          ".adoption-search__course-list-item-number"
        ).textContent = dataItem.class_nbr;

        this.listElement.appendChild(listItemElement);
      });
    }
  }
);
